import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if you needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id
})
var crud = new Crud('ShipmentStatuses', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  shipmentStatuses: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  shipmentStatuses: state => state.shipmentStatuses
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
